<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>Consultez et mettez à jour les documents officiels de votre compagnie.</span>
      </div>
    </div>

    <div class="ov-card sd-card">
      <div class="ov-card__head">
        <div class="ov-card__title">
          Documents
          <span class="ov-count">2</span>
        </div>
      </div>
      <v-progress-linear v-if="loading" indeterminate color="#159e72" height="2" />

      <!-- Attestation de transport -->
      <div class="sd-item">
        <div class="sd-item__icon">
          <v-icon size="22">mdi-file-certificate</v-icon>
        </div>
        <div class="sd-item__main">
          <div class="sd-item__kicker">Document n°1</div>
          <div class="sd-item__title">Attestation de Transport</div>
          <div class="sd-item__desc">
            Document officiel certifiant l'autorisation d'exploitation de transport de votre compagnie.
          </div>
        </div>
        <span class="ov-badge" :class="attestationTransportUrl ? 'ov-badge--success' : 'ov-badge--neutral'">
          {{ attestationTransportUrl ? 'Disponible' : 'Non défini' }}
        </span>
        <div class="sd-item__actions">
          <button
            type="button"
            class="ov-btn ov-btn--secondary ov-btn--sm"
            :disabled="!attestationTransportUrl || loading"
            @click="redirectToUrl(attestationTransportUrl)"
          >
            <v-icon small>mdi-eye</v-icon>
            Aperçu
          </button>
          <button
            type="button"
            class="ov-btn ov-btn--primary ov-btn--sm"
            @click="$router.push('/attestationTransport')"
          >
            <v-icon small>mdi-upload</v-icon>
            Gérer
          </button>
        </div>
      </div>

      <!-- Logo de la compagnie -->
      <div class="sd-item">
        <div class="sd-item__icon" :class="{ 'sd-item__icon--logo': logoCompagnieUrl }">
          <img v-if="logoCompagnieUrl" :src="logoCompagnieUrl" alt="Logo" />
          <v-icon v-else size="22">mdi-domain</v-icon>
        </div>
        <div class="sd-item__main">
          <div class="sd-item__kicker">Document n°2</div>
          <div class="sd-item__title">Logo de la compagnie</div>
          <div class="sd-item__desc">
            Image représentant votre compagnie, visible par tous les utilisateurs de la plateforme.
          </div>
        </div>
        <span class="ov-badge" :class="logoCompagnieUrl ? 'ov-badge--success' : 'ov-badge--neutral'">
          {{ logoCompagnieUrl ? 'Disponible' : 'Non défini' }}
        </span>
        <div class="sd-item__actions">
          <button
            type="button"
            class="ov-btn ov-btn--secondary ov-btn--sm"
            :disabled="!logoCompagnieUrl || loading"
            @click="redirectToUrl(logoCompagnieUrl)"
          >
            <v-icon small>mdi-eye</v-icon>
            Aperçu
          </button>
          <button
            type="button"
            class="ov-btn ov-btn--primary ov-btn--sm"
            @click="$router.push('/imageCompagnieTransport')"
          >
            <v-icon small>mdi-upload</v-icon>
            Gérer
          </button>
        </div>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_GET_DOCUMENT_URL,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import { showErrorMessage } from "../messages/messageProcess";

export default {
  name: "SelectionnerDocument",

  data() {
    return {
      errorMsg: null,
      loading: false,
      attestationTransportUrl: null,
      logoCompagnieUrl: null,
      attestationDocumentObject: {
        data: { typeDocument: null, compagnieTransportRaisonSociale: null },
      },
      logoDocumentObject: {
        data: { typeDocument: null, compagnieTransportRaisonSociale: null },
      },
    };
  },

  methods: {
    redirectToUrl(url) {
      window.open(url, "_blank", "fullscreen=yes");
    },

    async getUrlAttesationDocument() {
      this.attestationDocumentObject.data.typeDocument = "ATTESTATION_TRANSPORT";
      this.attestationDocumentObject.data.compagnieTransportRaisonSociale =
        this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
      await axios
        .post(API_GET_DOCUMENT_URL, this.attestationDocumentObject, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.data.status.code == 800) {
            this.attestationTransportUrl = response.data.item.url;
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        });
    },

    async getUrlLogoCompagnie() {
      this.logoDocumentObject.data.typeDocument = "LOGO";
      this.logoDocumentObject.data.compagnieTransportRaisonSociale =
        this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
      await axios
        .post(API_GET_DOCUMENT_URL, this.logoDocumentObject, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.data.status.code == 800) {
            this.logoCompagnieUrl = response.data.item.url;
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        });
    },
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
      this.getUrlAttesationDocument(),
      this.getUrlLogoCompagnie(),
    ]);
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.sd-card {
  max-width: 980px;
}

/* LIGNE DOCUMENT */
.sd-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border-bottom: 1px solid $ov-line;

  &:last-child {
    border-bottom: none;
  }
}

.sd-item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  overflow: hidden;
  border: 1px solid $ov-line;
  border-radius: 12px;
  background: rgba(21, 158, 114, 0.08);

  .v-icon {
    color: $ov-green !important;
  }

  &--logo {
    background: #ffffff;
  }

  img {
    width: 100%;
    height: 100%;
    padding: 4px;
    object-fit: contain;
  }
}

.sd-item__main {
  flex: 1;
  min-width: 0;
}

.sd-item__kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $ov-subtle;
}

.sd-item__title {
  margin-top: 2px;
  font-size: 15px;
  font-weight: 800;
  color: $ov-navy;
}

.sd-item__desc {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.5;
  color: $ov-muted;
}

.sd-item__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

@media (max-width: 760px) {
  .sd-item {
    flex-wrap: wrap;
  }

  .sd-item__main {
    flex-basis: calc(100% - 68px);
  }

  .sd-item__actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
